define([
	"dojo/_base/declare",
	"csi/table/New"
], function(declare,New) {

	// summary: Controller to create a Supplier (Supplier with IsSupplier=true) on an Agent (Supplier with IsAgent=true)
	return declare(New, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: on the create form, set value for IsSupplier to be true and make it read only
			view.addFixedValue("IsSupplier", true);

			this.inherited(arguments);
		}
	});
});